<template>
    <a-form class="session-form" :form="form">
        <a-row :gutter="[15, 0]">
            <a-col :span="24" v-if="abstract_list.length > 0">
                <a-form-item class="mb10" :label="$t('program.filter_paper') /* 可筛选论文 */">
                    <a-select v-decorator="['abstract_id_sx', { rules: [{ required: false }] }]" @change="handleSetUserInfoEvent" allowClear>
                        <a-select-option v-for="(item, index) in abstract_list" :key="index" :value="item.id">
                            <template v-if="userType == 'cn'">
                                {{ item.number }} {{ item.title }} {{ item.real_name }} {{ item.is_selected ? $t('program.added' /* 已添加 */) : $t('program.not_added' /* 未添加 */) }}
                            </template>
                            <template v-else>
                                {{ item.number }} {{ item.title_en }} {{ `${item.given_name} ${item.family_name}` }}
                                {{ item.is_selected ? $t('program.added' /* 已添加 */) : $t('program.not_added' /* 未添加 */) }}
                            </template>
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </a-col>
            <a-col :span="24">
                <a-form-item class="mb10" :label="$t('program.add_title_search') /* 标题/ID搜索 */" style="width: 100%">
                    <a-input v-model="searchVal" :placeholder="$t('program.p_add_title_search') /* 请输入标题/ID进行搜索 */" style="width: 100%" @change="handleChangeEvent"></a-input>
                </a-form-item>
            </a-col>
            <!-- 通道id -->
            <a-form-item style="display: none">
                <a-input v-decorator="['channel_id', { rules: [{ required: false }] }]"></a-input>
            </a-form-item>
            <a-form-item style="display: none">
                <a-input v-decorator="['class_id', { rules: [{ required: false }] }]"></a-input>
            </a-form-item>
            <a-col :span="24">
                <a-form-item style="width: 100%" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }">
                    <a-radio-group class="title-list" v-decorator="['abstract_id', { rules: [{ required: false }] }]" @change="handleSelectChangeEvent" v-show="abstractList.length > 0">
                        <a-radio v-for="(item, index) in abstractList" :key="index" :value="item.id" @click="handleCancelEvent(item.id)">
                            <div class="flex y-center flex-wrap x-left">
                                <span v-if="item.count != 0" style="color: red">[{{ $t('program.added_num', { num: item.count }) }}]</span>
                                <a-divider type="vertical"></a-divider>
                                <span>{{ $t('program.paper_id' /* 讲题ID */) }}:{{ item.number }}</span>
                                <a-divider type="vertical"></a-divider>
                                <span>{{ $t('program.paper_title' /* 标题 */) }}:{{ userType == 'cn' ? item.title : item.title_en }}</span>
                                <a-divider type="vertical"></a-divider>
                                <span>{{ $t('program.speaker' /* 讲者 */) }}:{{ userType == 'cn' ? item.real_name : `${item.given_name} ${item.family_name}` }}</span>
                                <a-divider type="vertical"></a-divider>
                                <span>{{ $t('program.unit' /* 单位 */) }}:{{ userType == 'cn' ? item.org_cnname : item.org_enname }}</span>
                                <a-divider type="vertical"></a-divider>
                                <span>{{ $t('program.phone' /* 手机 */) }}:{{ item.mobile }}</span>
                            </div>
                        </a-radio>
                    </a-radio-group>
                    <div>
                        <span class="mr10">{{ $t('program.no_query_paper' /* 如未查询到论文稿件信息请点击 */) }}</span>
                        <a-button
                            icon="plus"
                            type="primary"
                            @click="
                                currentSelect = {};
                                form.setFieldsValue({ abstract_id: '', abstract_title: searchVal,abstract_title_en: searchVal  })
                            "
                        >
                            {{ $t('program.new' /* 新增 */) }}
                        </a-button>
                    </div>
                </a-form-item>
            </a-col>
            <a-col :span="24">
                <a-form-item style="width: 100%" :label="$t('program.paper_id' /* 讲题ID */)">
                    <div style="color: red">{{ currentSelect.number || $t('program.wait_to_add' /* 待新增 */) }}</div>
                </a-form-item>
            </a-col>
            <a-col :span="24">
                <a-form-item style="width: 100%" :label="$t('program.cn_title' /* 中文标题 */)">
                    <a-input
                        :placeholder="$t('program.p_cn_title' /* 请输入中文标题 */)"
                        v-decorator="['abstract_title', { rules: [{ required: true, message: $t('program.p_cn_title' /* 请输入中文标题 */) }] }]"
                    ></a-input>
                </a-form-item>
            </a-col>
            <a-col :span="24">
                <a-form-item style="width: 100%" :label="$t('program.en_title' /* 英文标题 */)">
                    <a-input
                        :placeholder="$t('program.p_en_title' /* 请输入英文标题 */)"
                        v-decorator="['abstract_title_en', { rules: [{ required: true, message: $t('program.p_en_title' /* 请输入英文标题 */) }] }]"
                    ></a-input>
                </a-form-item>
            </a-col>
            <a-col :span="24">
                <a-form-item style="width: 100%" :label="$t('program.fayan_type' /* 发言形式 */)">
                    <a-radio-group v-decorator="['type_id', { rules: [{ required: true, message: $t('program.p_fayan_type' /* 请选择发言形式 */) }] }]">
                        <a-radio-button class="mb5" v-for="(item, index) in typeList" :value="item.id" :key="index">
                            {{ userType == 'cn' && $route.params.lang == 'cn' ? item.typename_cn : item.typename_en }}
                        </a-radio-button>
                    </a-radio-group>
                </a-form-item>
            </a-col>
        </a-row>
    </a-form>
</template>
<script>
const fileds = ['abstract_title', 'abstract_title_en', 'type_id', 'abstract_id', 'channel_id', 'class_id', 'abstract_id_sx'];
import moment from 'moment';
import debounce from 'lodash.debounce';
import pick from 'lodash.pick';
export default {
    name: 'searchTitle',
    props: {
        programInfo: {
            default: () => {},
            type: Object
        },
        userType: {
            default: 'cn',
            type: String
        },
        abstract_list: {
            default: () => [],
            type: Array
        }
    },
    data() {
        return {
            visible: false,
            loading: false,
            form: this.$form.createForm(this),
            abstractList: [],
            currentSelect: {},
            typeList: [],
            searchVal: ''
        };
    },
    computed: {},
    watch: {
        programInfo: {
            handler(newVal) {
                if (newVal.abstract_data) {
                    newVal.class_id = newVal.abstract_data.class_id;
                    newVal.channel_id = newVal.channel_id;
                }
                this.form.setFieldsValue(pick(newVal, fileds));
                this.currentSelect = newVal.abstract_data;
            }
        }
    },
    methods: {
        reset() {
            this.abstractList = [];
            this.currentSelect = {};
            this.form.resetFields();
        },
        handleChangeEvent(e) {
            const { value } = e.target;
            if (value) {
                debounce(() => {
                    this.searchAbstract(value);
                }, 500)();
            }
        },
        handleCancelEvent(id) {
            if (id == this.form.getFieldValue('abstract_id')) {
                this.form.setFieldsValue({ abstract_id: '', channel_id: '', class_id: '' });
                this.currentSelect = {};
            }
        },
        searchAbstract(name) {
            this.$request.get({ url: 'searchAbstract', data: { name } }).then(res => {
                if (res.code == 200) {
                    this.abstractList = res.data;
                }
            });
        },
        handleSelectChangeEvent(e) {
            let { value } = e.target;
            if (value) {
                let list = this.abstractList.filter(item => item.id == value);
                this.currentSelect = list[0];
                this.form.setFieldsValue({
                    abstract_title: this.currentSelect.title,
                    abstract_title_en: this.currentSelect.title_en,
                    abstract_id: this.currentSelect.id,
                    channel_id: this.currentSelect.channel_id,
                    class_id: this.currentSelect.class_id
                });
            } else {
                this.currentSelect = {};
            }
            this.$emit('setUser', this.currentSelect);
        },
        getProgramFayanList() {
            this.$request.get({ url: 'getProgramFayanList', data: { type: 2 } }).then(res => {
                this.typeList = res.data;
            });
        },
        validate() {
            return new Promise((resolve, reject) => {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        resolve(values);
                    }
                });
            });
        },
        handleSetUserInfoEvent(value) {
            if (value) {
                let item = this.abstract_list.filter(item => item.id == value);
                this.form.setFieldsValue({
                    abstract_title: item[0].title,
                    abstract_title_en: item[0].title_en
                });
                this.$emit('setUser', JSON.parse(JSON.stringify(item[0])));
            } else {
                this.form.setFieldsValue({
                    abstract_title: '',
                    abstract_title_en: ''
                });
                this.$emit('setUser', {});
            }
        }
    },
    created() {
        fileds.forEach(v => this.form.getFieldDecorator(v));
        this.getProgramFayanList();
    },
    mounted() {}
};
</script>
<style lang='less' scoped>
/deep/.title-list {
    max-height: 200px;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
    overflow: auto;
    border: 1px solid #4d9ff8;
    background: #f7faff;
    width: 100%;
    .ant-radio-wrapper {
        padding: 10px 0;
        border-bottom: 1px solid #ddd;
        white-space: pre-wrap;
        display: flex;
        justify-content: left;
        align-items: center;
        &:last-child {
            border-bottom: none;
        }
        span {
            &:last-child {
                display: flex;
                align-content: center;
                flex-wrap: wrap;
            }
        }
    }
}
</style>